import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { NGXLogger } from "ngx-logger";
import { AuthService } from "./auth.service";
import { SetGuardedRoute } from "./state/auth/auth.actions";
import { B2cService } from "./b2c.service";

@Injectable({ providedIn: "root" })
export class AuthGuardService {
  constructor(
    private logger: NGXLogger,
    private auth: AuthService,
    private b2cService: B2cService,
    private store: Store<any>,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    this.logger.trace(`AUTH GUARD: can activate?`, state.url);
    const idpParam = route.queryParams.idp;

    const isTokenValid = this.auth.validateToken(idpParam);

    if (idpParam && !isTokenValid) {
      this.b2cService.startB2cLogin(idpParam, state.url);
    }
    this.store.dispatch(new SetGuardedRoute(state.url));
    this.logger.debug(`AUTH GUARD: activated`, isTokenValid);
    return isTokenValid;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    return this.canActivate(route, state);
  }
}
